// client/src/pages/AndroidAppPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AndroidAppPage.css'; // Import CSS
// Import your logo.  Adjust the path as needed.
import logo from '../assets/logo.png'; //  Replace with YOUR logo path

function AndroidAppPage() {
    const { t } = useTranslation();

    return (
        <div className="android-app-page">
            <img src={logo} alt={t('AndroidAppPage.logoAlt')} className="app-logo" />
            <h1>{t('AndroidAppPage.title')}</h1>
            <p>{t('AndroidAppPage.message')}</p>
            <a
                href="https://play.google.com/store/apps/details?id=your.app.id" // Replace with your app's URL
                className="download-button"
            >
                {t('AndroidAppPage.downloadLink')}
            </a>
        </div>
    );
}

export default AndroidAppPage;